jQuery(function($) {

    $('#pdmp-calculate-time-button').on( "click", function(e) {
        e.preventDefault();
        let numberOfPatients = $('.calculator-dropdown').val();
        let minutes = 4.22 * numberOfPatients;
        let lastValue = $('.calculator-dropdown option:last-child').val();
        if (lastValue == numberOfPatients) {
            minutes = Math.pow(minutes, 1.5);
        }
        let estimateTime = timeConvert(minutes.toFixed(2));
        $('#pdmp-estimate-time .elementor-widget-container').html('<p>'+estimateTime+'</p>');
    });

    // trigger click
    if ($('#pdmp-calculate-time-button')) {
        $('#pdmp-calculate-time-button').trigger('click');
    }
   
});

function timeConvert(n) {
    // Store the input number of minutes in a variable num
    var num = n;
    // Calculate the total hours by dividing the number of minutes by 60
    var hours = (num / 60);
    // Round down the total hours to get the number of full hours
    var rhours = Math.floor(hours);
    // Calculate the remaining minutes after subtracting the full hours from the total hours
    var minutes = (hours - rhours) * 60;
    // Round the remaining minutes to the nearest whole number
    var rminutes = Math.round(minutes);
    // Construct and return a string representing the conversion result
    return rhours + " Hour(s) " + rminutes + " Minute(s)";
}